import React, { Component } from 'react';

import { isEmpty } from "lodash";

import ColorPicker from '../../common/ColorPicker';
import { normalizeStr } from '../../../utils/generalFuncs';
import InputText from '../../common/Form';
import { Box, OutlinedInput, InputLabel, Select, Typography, FormHelperText, FormControl } from '@mui/material';
import Dialog from '../../common/Dialog';
import { Fragment } from 'react';
import Creatable from '../../common/Creatable';

class CategoriesForm extends Component {
    state = { 
        category_name: this.props.category ? this.props.category.category_name : "",
        category_parent: this.props.category ? this.props.category.category_parent : "",
        category_parentDisplay: this.props.category && this.props.category.category_parent ? {
            value: this.props.category.category_parent, 
            label: this.props.CATEGORIES.PARENT[this.props.category.category_parent].category_name
        } : {value:"", label:""},
        category_sub_parent: this.props.category ? this.props.category.category_sub_parent : "",
        category_sub_parentDisplay: this.props.category && this.props.category.category_sub_parent ? {
            value: this.props.category.category_sub_parent, 
            label: this.props.CATEGORIES.CHILD[this.props.category.category_sub_parent].category_name
        } : {value:"", label:""},
        category_color: this.props.category ? this.props.category.category_color : "",
        category_equipement_code: this.props.category ? this.props.category.category_equipement_code : "",
        category_accounting_id: this.props.category ? this.props.category.category_accounting_id : "",
        errors:{
            category_name: "",
            category_parent: "",
            category_color: "",
            category_equipement_code: "",
        },
        exist: []
    }
    componentDidMount = () => {
        this.getAvailableColorsList()
        console.log('====================================');
        console.log(this.props.category);
        console.log('====================================');
    }
    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value

        // if(name === "category_parent" && !isEmpty(value)){
        //     let color = this.props.CATEGORIES.PARENT[value].category_color
        //     this.setState({
        //         category_color: color,
        //         category_sub_parent: "",
        //     })
        // }

        this.setState({
            [name]: value
        })
    }
    handleChangeCat = (name, option) => {
        if(option){
            if(name === "category_parent" && !isEmpty(option.value)){
                let color = this.props.CATEGORIES.PARENT[option.value].category_color
                this.setState({
                    category_color: color,
                    category_sub_parent: "",
                    [name]: option.value || "",
                    [`${name}Display`]: option
                })
            } else {

                this.setState({
                    [name]: option.value || "",
                    [`${name}Display`]: option
                })
            }
        } else {
            this.setState({
                [name]: "",
                [`${name}Display`]: {}
            })

        }
    }
    setColor = (color) => {
        this.setState({
            category_color: color
        })
    }
    
    nameExist = (name, isParent, id) => {
        const { CATEGORIES } = this.props;
        let list = []
        if(isParent){
            list = Object.values(CATEGORIES.PARENT).filter(cat => ( 
                    (normalizeStr(cat.category_name) === normalizeStr(name) ) && 
                    (cat.category_id !== id) 
                ))
            
        } else {
            list = Object.values(CATEGORIES.CHILD).filter(cat => ( 
                    (normalizeStr(cat.category_name) === normalizeStr(name) ) && 
                    (cat.category_id !== id) 
                ) )
        }

        console.log("Category exist",{list});

        return !isEmpty(list)
    }
    validate = () => {
        let required = [
            "category_name",
            "category_color",
            "category_accounting_id",
            // "category_equipement_code",
        ]
        
        // if( this.state.category_parent) {
        //     required.push("category_equipement_code")
        // }

        let noError = true
        let errors = {}
        required.map(field => {
            if(!this.state[field]){
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })
    
        this.setState({
            errors
        })
        return noError
    }
    handleSubmit = async () => {
        if(this.validate()){
            let data = {}
            
            if (this.props.update) {
                data = Object.assign(data, this.props.category)
            }

            data.category_name = this.state.category_name.toUpperCase()
            data.category_parent = this.state.category_parent
            data.category_sub_parent = this.state.category_sub_parent
            data.category_accounting_id = this.state.category_accounting_id
            data.category_color = this.state.category_color
            data.category_equipement_code = this.state.category_equipement_code ? this.state.category_equipement_code.toUpperCase().trim() : ""

            // console.log('====================================');
            // console.log({data});
            // console.log('====================================');
    
            data.is_parent = isEmpty(data.category_parent)
            data.is_child = !isEmpty(data.category_parent)
            
            // check if name exist
            if(this.nameExist(data.category_name, data.is_parent, data.category_id) ){
                this.props.notif("error",`Cette catégorie existe déjà`)
                return
            }

            if(this.props.update){
                await this.props.updateCategory(data)
            } else {
                await this.props.newCategory(data)  
            }

            if(this.props.STATE.categories.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.categories.error}`)
            } else{
                !this.props.update && this.props.notif("success","La categorie a été créée avec succès")
                this.props.update && this.props.notif("success","La categorie a été modifiée avec succès")
                this.props.handleClose()
            }
            
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs" )
        }
    }
    getAvailableColorsList = () => {
        const { CATEGORIES } = this.props;
        let exist = []
        Object.values(CATEGORIES.PARENT).forEach( cat => {
            exist.push(cat.category_color)
        })
        this.setState({
            exist
        })
    }
    render() {
        const { CATEGORIES } = this.props;
        return (
            <Dialog
                close={this.props.handleClose}
                title={`${this.props.update ? "Modifier la " : "Créer une nouvelle"} Catégorie`}
                disabledSubmit={this.props.STATE.categories.fetching}
                submitTitle={this.props.update ? "Modifier" : "Créer"}
                submitAction={this.handleSubmit}
                appBar
                maxWidth="md"
            >
                <InputText
                    required
                    name="category_name" 
                    id="category_name" 
                    value={this.state.category_name} 
                    label="Nom de la catégorie" 
                    error={this.state.errors.category_name} 
                    onChange={this.handleChange}
                />

                {!this.props.hasChild &&
                    <Fragment>
                            {/* <FormControl variant="outlined" style={{width: "100%"}}>
                                <InputLabel htmlFor="category_parent">Catégorie principale</InputLabel>
                                <Select
                                    native
                                    onChange={this.handleChange}
                                    value={this.state.category_parent}
                                    input={<OutlinedInput labelWidth={200} name="category_parent" id="category_parent" />}
                                >
                                    <option value="" />
                                    { Object.values(CATEGORIES.PARENT).map( category  => (
                                        <option 
                                            value={category.category_id} 
                                            key={category.category_id} 
                                        >{category.category_name}</option>
                                    )) }
                                </Select>
                                <FormHelperText></FormHelperText>
                            </FormControl> */}
                            <Creatable
                                label="Catégorie Principale"
                                required
                                error={this.state.errors.category_parent}
                                id="category_parent"
                                options={Object.values(CATEGORIES.PARENT).filter(c => c.is_active !== false).map( item => ({
                                    label: item.category_name,
                                    value: item.category_id
                                }))}
                                value={this.state.category_parentDisplay}
                                onChange={(option) => this.handleChangeCat("category_parent", option)}
                            />
                    
                        {this.state.category_parent && CATEGORIES.ALL[this.state.category_parent] &&
                                //  <FormControl variant="outlined" style={{width: "100%"}} gutterBottom >
                                //     <InputLabel htmlFor="category_sub_parent">Sous Catégorie</InputLabel>
                                //     <Select
                                //         native
                                //         onChange={this.handleChange}
                                //         value={this.state.category_sub_parent}
                                //         input={<OutlinedInput labelWidth={130} name="category_sub_parent" id="category_sub_parent" />}
                                //     >
                                //         <option value="" />
                                //         { CATEGORIES.ALL[this.state.category_parent] && CATEGORIES.ALL[this.state.category_parent].map( subcat => (
                                //             <option 
                                //                 value={subcat} 
                                //                 key={subcat} 
                                //                 disabled={this.props.category && 
                                //                     subcat === this.props.category.category_id
                                //                 }
                                //             >{CATEGORIES.CHILD[subcat] && CATEGORIES.CHILD[subcat].category_name}</option>
                                            
                                //         )) }
                                //     </Select>
                                //     <FormHelperText></FormHelperText>
                                // </FormControl> 
                                <Creatable
                                    label="Sous Catégorie"
                                    required
                                    error={this.state.errors.category_sub_parent}
                                    id="category_sub_parent"
                                    options={CATEGORIES.ALL[this.state.category_parent] && CATEGORIES.ALL[this.state.category_parent]
                                    .filter(subcat => CATEGORIES.CHILD[subcat] && CATEGORIES.CHILD[subcat].is_active !== false)
                                    .map( subcat => ({
                                        label: CATEGORIES.CHILD[subcat] && CATEGORIES.CHILD[subcat].category_name,
                                        value: subcat,
                                        disabled: this.props.category && 
                                            subcat === this.props.category.category_id
                                    }))}
                                    value={this.state.category_sub_parentDisplay}
                                    onChange={(option) => this.handleChangeCat("category_sub_parent", option)}
                                />
                                
                        }
                    </Fragment>
                }
                {this.state.category_parent && 
                    <InputText
                        // required
                        name="category_equipement_code" 
                        id="category_equipement_code" 
                        value={this.state.category_equipement_code} 
                        label="Code Reference" 
                        placeholder="ex: MI" 
                        onChange={this.handleChange}
                        error={this.state.errors.category_equipement_code} 
                    />
                }

                <InputText
                    type="number"
                    required
                    name="category_accounting_id" 
                    id="category_accounting_id" 
                    value={this.state.category_accounting_id} 
                    label="Classe Comptable" 
                    placeholder="ex: 607" 
                    onChange={this.handleChange}
                    error={this.state.errors.category_accounting_id} 
                />

                <FormControl variant="outlined"  error={!!this.state.errors.category_color} style={{width: "100%",}}>
                    <Typography>Couleur de la catégorie (Catégorie principale)</Typography>
                    <Box style={{
                            backgroundColor:this.state.category_color,
                            width: "50px",
                            height: "50px"
                        }}
                    >
                    </Box>
                    <FormHelperText>{this.state.errors.category_color}</FormHelperText>
                </FormControl>

                {!this.state.category_parent &&
                // {!this.state.category_parent && !this.props.hasChild &&
                    <Box style={{overflow: "auto"}}>
                        <ColorPicker setColor={this.setColor} selected={this.state.category_color} notAvailable={this.state.exist} />
                    </Box>
                }
            </Dialog>
            
        );
    }
}

export default CategoriesForm;